<template>
  <div class="pt-3" :style="top ? `margin-top: ${top}px` : ''">
   <div class="my-4 px-2 d-flex align-content-center" :style="`background-color: ${isTargetShop ? '#FFA300' : $colorSub}`">
     <v-row no-gutters>
       <v-col class="pl-3 font18 py-2">
        <div class="d-flex justify-content-start">
         <img v-if="!isTargetShop" :src="promotionIcon" class="me-2" :width="isTargetShop ? 30: 20" :height="checkpushCustom() ? 30: 20"/>
         <div class="pb-0 ms-2" :style="{'color': textColor}">
           {{ isTargetShop ? $t("message.campaign") : $t("message.promotion")  }}
         </div>
        </div>
       </v-col>
       <v-col
         class="text-end pr-0 link py-2" :style="{'color': textColor}"
         @click="$router.push('/C/promotion')"
         >{{ $t("message.viewAll") }}
         <v-icon :color="textColor">mdi-chevron-right</v-icon>
       </v-col>
     </v-row>
   </div>
  </div>
</template>
<style scoped>
.v-sheet.v-card {
    border-radius: 14px;
}
#primary {
  background-color: #181446;
}
</style>
<script>
export default {
  components: {
  },
  props: {
    top: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      // colorSub: '',
      // colorSub2: '',
      // colorSub3: ''
    }
  },
  computed: {
    isTargetShop () {
      return this.$isTargetShop()
    },
    computedStyle () {
      return this.isTargetShop ? this.fontColorLMG : this.$textcolor
    },

    textColor () {
      return this.isTargetShop ? '#000' : this.$colorSub2
    },
    promotionIcon () {
      if (!this.checkpushCustom()) {
        return require('@/assets/Promotin.png')
      }
      return this.isTargetShop ? this.$images.promotionBlack : (this.$colorSub3 ? this.$images.promotionBlack : this.$images.promotionWhite)
    }
  },
  async mounted () {
    // this.colorSub = await this.rgbaToHex()
    // this.colorSub2 = await this.HEXToVBColorLMG(this.colorSub)
    // this.colorSub3 = await this.HEXTHEMELMG(this.colorSub)
  },
  methods: {
    HEXToVBColorLMG (hex) {
      if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(hex)) {
        return '#E0E0E0'
      }

      let rr = parseInt(hex.substring(1, 3), 16)
      let gg = parseInt(hex.substring(3, 5), 16)
      let bb = parseInt(hex.substring(5, 7), 16)

      let brightness = (rr * 0.299) + (gg * 0.587) + (bb * 0.114)

      // console.log('brightness', brightness)

      if (brightness > 180) {
        return '#000000' // สีเข้ม
      } else {
        return '#FFFFFF' // สีขาว
      }
    },
    HEXTHEMELMG (hex) {
      if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(hex)) {
        return true
      }

      let rr = parseInt(hex.substring(1, 3), 16)
      let gg = parseInt(hex.substring(3, 5), 16)
      let bb = parseInt(hex.substring(5, 7), 16)

      let brightness = (rr * 0.299) + (gg * 0.587) + (bb * 0.114)

      return brightness > 180
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Layouts/Promotions.vue